import { produce } from 'immer';
import {
  CLEAR_CATALOG_SEARCH,
  FETCH_CATALOG_SEARCH,
  FETCH_CATALOG_SEARCH_FULFILLED,
  FETCH_CATALOG_SEARCH_REJECTED,
} from 'b2b-apps/shop/catalog/redux/search/actionTypes';
import { CatalogSearchActions, CatalogSearchState, CatalogSearchType } from 'b2b-apps/shop/catalog/redux/search/types';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';

const initialData: CatalogSearchType = {
  filters: [],
  navigation: {
    available: [],
    selected: [],
    suggested: [],
  },
  products: [],
  productsCount: 0,
  query: '',
  requestedQuery: '',
  site: null,
  sortingOptions: [],
};

const initialState: CatalogSearchState = Object.assign(
  RemoteRecordData.getDefault(),
  {
    data: initialData,
  },
);

const reducer = (
  state: CatalogSearchState = initialState,
  action: CatalogSearchActions,
): CatalogSearchState => {
  switch (action.type) {
    case CLEAR_CATALOG_SEARCH:
      return produce(state, (draft: CatalogSearchState) => {
        if (draft.data) {
          draft.data.products = initialData.products;
          draft.data.productsCount = initialData.productsCount;
        }
      });

    case FETCH_CATALOG_SEARCH:
      return produce(state, (draft: CatalogSearchState) => Object.assign(RemoteRecordData.init(), {
        data: draft.data,
      }));

    case FETCH_CATALOG_SEARCH_FULFILLED: {
      const { data, identifier } = action.payload;

      return RemoteRecordData.fulfill(data, identifier);
    }

    case FETCH_CATALOG_SEARCH_REJECTED:
      return produce(state, (draft: CatalogSearchState) => Object.assign(
        RemoteRecordData.reject(action.payload.error, draft.identifier),
        {
          data: draft.data,
        },
      ));

    default:
      return state;
  }
};

export {
  reducer,
};
